import React from "react";
import { Button } from "../../utils/Button";
import { CgClipboard } from "react-icons/cg";
import { BsChevronLeft, BsDownload } from "react-icons/bs";
export const Oderpage = ({setShowOrderPage, order, getStatusColor }) => {
  return (
    <div className="w-[540px] dark:border-[#3d3d3d]">
        <button onClick={() => setShowOrderPage(false)} className="flex items-center space-x-2">
            <BsChevronLeft className="text-xl"/>
            <p className="text-[28px] md:text-[32px]">Back to My Orders</p>
        </button>
        <div className="border-2 border-dashed rounded-lg dark:border-[#3d3d3d] my-4">
      <div className="flex p-4 justify-between items-center">
        <h1 className="text-3xl">Order #{order?.orderNumber}</h1>
        <Button
          iconLeft={<CgClipboard />}
          att={"bg-black text-white dark:bg-white dark:!text-black"}
          name="Get Invoice"
        />
      </div>
      <div className="flex px-4 items-center justify-between w-1/2">
        <p>Date:</p>
        <p>{order?.date}</p>
      </div>
      <div className="py-2 px-4 flex items-center justify-between w-1/2">
        <p>Payment Method:</p>
        <p className="">PayPal</p>
      </div>
      <div className="flex px-4 items-center justify-between w-1/2">
        <p>Status:</p>
        <p
          className={`rounded-lg px-2 py-1 w-fit ${getStatusColor(order?.status)}`}
        >
          {order?.status}
        </p>
      </div>
      <hr className="my-2 dark:border-[#3d3d3d]"/>
      <div className="px-4">
      {order?.products.map((product, index) => (
        <div
          key={product.name}
          className={`flex items-center justify-between py-4 ${
            order?.products.length > 1 && (index > 0 || index === order?.products.length - 1) ? "border-t dark:border-[#3d3d3d]" : ""
          }`}
        >
          <img className="w-10 rounded" src={product.img} alt={product.name} />
          <p>{product.name}</p>
          <p>${product.price}</p>
            <Button
              iconLeft={<BsDownload />}
              att={"bg-white text-black border border-black"}
              name="Download"
            />
        </div>
      ))}
    </div>
      <hr className="mt-2 dark:border-[#3d3d3d]"/>
      <div className="px-4 py-4">
        <div className="flex items-center justify-between">
            <p>Cart Items:</p>
            <p>$120</p>
        </div>
        <div className="flex py-2 items-center justify-between">
            <p>VAT (19%)</p>
            <p>$22.8</p>
        </div>
        <div className="flex items-center justify-between">
            <p>Total Paid:</p>
            <p>$148.8</p>
        </div>
      </div>
      </div>
    </div>
  );
};
